<ul class="pv-menu-list">
  <li>
    <span>{{ 'clippingPanel.clipType' | transloco }}</span>
    <app-dropdown
      [value]="currentClipTask"
      [options]="clipTaskOptions"
      (valueChange)="onClipTaskChange($event)"
      width="100%"
    ></app-dropdown>
  </li>
  <li class="measurement-grid">
    <app-button
      (click)="startClipVolume()"
      variant="secondary"
      [title]="'clippingPanel.newClipping' | transloco"
    >
      {{ 'clippingPanel.newClipping' | transloco }}
    </app-button>
  </li>
  <div class="divider" *ngIf="volumes().length">
    <span>{{ 'clippingPanel.volumes' | transloco }}</span>
  </div>
  <li *ngIf="volumes().length">
    <div class="volume-list">
      <div
        class="volume-item"
        *ngFor="let v of volumes()"
        [class.selected]="v.id === selectedVolumeId()"
        (click)="onSelectVolume(v.id)"
      >
        <span
          class="vis"
          [class.off]="!v.clip"
          (click)="onToggleVolumeClip(v); $event.stopPropagation()"
        >
          ●
        </span>
        <span class="name">{{ v.name }}</span>
        <span
          class="remove-btn"
          [title]="'clippingPanel.removeVolume' | transloco"
          (click)="onRemoveVolume(v.id, $event)"
          style="margin-left: auto; cursor: pointer; color: #c33"
        >
          ✕
        </span>
      </div>
    </div>
  </li>

  <li *ngIf="selectedVolumeId() && volumeDetails">
    <div class="volume-edit-grid">
      <table class="measurement_value_table" style="width: 100%; margin-bottom: 6px">
        <tr>
          <th style="text-align: center">α</th>
          <th style="text-align: center">β</th>
          <th style="text-align: center">γ</th>
        </tr>
        <tr>
          <td style="text-align: center">{{ volumeDetails.rotationDeg[0] | number: '1.1-1' }}°</td>
          <td style="text-align: center">{{ volumeDetails.rotationDeg[1] | number: '1.1-1' }}°</td>
          <td style="text-align: center">{{ volumeDetails.rotationDeg[2] | number: '1.1-1' }}°</td>
        </tr>
      </table>
      <table class="measurement_value_table" style="width: 100%; margin-bottom: 6px">
        <tr>
          <th style="text-align: center">{{ 'clippingPanel.length' | transloco }}</th>
          <th style="text-align: center">{{ 'clippingPanel.width' | transloco }}</th>
          <th style="text-align: center">{{ 'clippingPanel.height' | transloco }}</th>
        </tr>
        <tr>
          <td style="text-align: center">{{ volumeDetails.scale[0] | number: '1.2-2' }}</td>
          <td style="text-align: center">{{ volumeDetails.scale[1] | number: '1.2-2' }}</td>
          <td style="text-align: center">{{ volumeDetails.scale[2] | number: '1.2-2' }}</td>
        </tr>
      </table>
      <div style="font-size: 12px; line-height: 1.4">
        <div>
          <strong>X:</strong>
          {{ volumeDetails.position[0] | number: '1.2-2' }}
        </div>
        <div>
          <strong>Y:</strong>
          {{ volumeDetails.position[1] | number: '1.2-2' }}
        </div>
        <div>
          <strong>Z:</strong>
          {{ volumeDetails.position[2] | number: '1.2-2' }}
        </div>
        <div>
          <strong>Volume:</strong>
          {{ volumeDetails.volume | number: '1.2-2' }}
        </div>
      </div>
    </div>
  </li>
</ul>
